import { render } from "./ProductFormTabMain.vue?vue&type=template&id=30f67182&scoped=true"
import script from "./ProductFormTabMain.vue?vue&type=script&lang=js"
export * from "./ProductFormTabMain.vue?vue&type=script&lang=js"

import "./ProductFormTabMain.vue?vue&type=style&index=0&id=30f67182&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f67182"]])

export default __exports__